import styled from 'styled-components';
import { Colors } from '~/config/Colors';
import { SLForm } from '~/pages/Sistema/componentes/SistemaList';

export const Container = styled(SLForm)`
  display: flex;
  flex-direction: column;
  gap: 24px;

  width: 100%;
  height: 100%;
  padding: 16px;
  margin-bottom: 24px;

  border-radius: 20px;
`;

export const QuickSelectCard = styled.div`
  display: flex;
  flex-direction: column;

  border: 1px solid ${Colors.Border_Color_1};
  background-color: transparent;
  border-radius: 12px;
  padding: 16px;

  box-shadow: rgba(0, 0, 0, 0.3) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
`;

export const QuickSelectButtons = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

export const QuickSelectButton = styled.button`
  padding: 8px 16px;
  border: 1px solid ${Colors.Border_Color_1};
  background-color: ${props => (props.selected ? Colors.Input_Color_1 : 'transparent')};
  border-radius: 8px;
  color: ${Colors.text_Color_1};
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 500;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${Colors.Input_Color_1};
    border-color: ${Colors.Input_Color_1};
  }

  ${props =>
    props.selected &&
    `
    background-color: ${Colors.Input_Color_1};
    border-color: ${Colors.Input_Color_1};
  `}
`;

export const CustomInputContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const Table = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${Colors.bgCardColor};
  margin-top: 24px;
  margin-bottom: 24px;

  border-radius: 12px;
  text-align: center;

  border: 1px solid ${Colors.Border_Color_1};
  box-shadow: rgba(0, 0, 0, 0.3) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;

  .skeleton {
    background: ${localStorage.getItem('tema') == 'E'
      ? 'linear-gradient(90deg, #ffffff15 25%, #ffffff05 50%, #ffffff10 75%)'
      : 'linear-gradient(90deg, #6796cf50 25%, #6796cf25 50%, #6796cf50 75%)'};
    background-size: 200% 100%;
    animation: skeleton-loading 4s infinite linear;
    border-radius: 4px;
  }

  @keyframes skeleton-loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 2fr 1.5fr 1fr 1fr;
  width: 100%;
  padding-block: 24px;
  padding-inline: 48px;
  gap: 16px;
  background-color: #6796cf;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;

  font-size: 16px;
  color: ${Colors.Color30};
  font-weight: 500;
  line-height: 24px;
`;

export const TableBody = styled.div`
  display: grid;
  grid-template-columns: 2fr 1.5fr 1fr 1fr;
  align-items: center;
  width: 100%;
  padding-block: 8px;
  padding-inline: 48px;
  gap: 16px;

  font-size: 16px;
  color: ${Colors.text_Color_1};
  font-weight: 300;
  line-height: 24px;

  border-bottom: 1px solid
    ${props => (props.hasBorder ? `${Colors.Border_Color_1}` : 'transparent')};
  &:last-child {
    border-bottom: none;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SaveButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;

  background-color: #4caf50;
  border: none;
  border-radius: 8px;
  color: white;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;

  transition: all 0.3s ease;

  &:hover {
    background-color: #45a049;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }

  i {
    animation: ${props => (props.disabled ? 'spin 1s linear infinite' : 'none')};
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
